import script from "./AuthCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthCard.vue?vue&type=script&lang=ts&setup=true"

import "./AuthCard.vue?vue&type=style&index=0&id=5bf5010b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf5010b"]])

export default __exports__